module.exports = __webpack_public_path__ + "static/media/kishoriB1.3a468c1f.png";